module.exports = __webpack_public_path__ + "img/lacrosse-stick.65cd2e72.svg";